export default {
    contract: {
        management: "Vertragsverwaltung",

        edit: {
            store : "Änderungen speichern",
            on    : "Bearbeiten beenden",
            off   : "Bearbeiten",
            stored: "Die Änderungen wurden gespeichert!"
        },

        title               : "Vertrag",
        addresses           : "Adressen",
        billing             : "Rechnungserstellung",
        companies           : "Beteiligte Unternehmen",
        create: {
            all: "Neuen Vertrag anlegen",
            mnt: "Neuen Wartungsvertrag anlegen",
            esc: "Neuen Notrufvertrag anlegen",
            lim: "Neuen Liftmanagement Vertrag anlegen",
            dls: "Neuen DLS Vertrag anlegen",
            zus: "Neuen ZÜS Vertrag anlegen"
        },
        hcid                : "HC-ID",
        start               : "Vertragsbeginn",
        expiration          : "Vertragsende",
        terms               : "Konditionen",
        company             : "Vertragspartner",
        termsOfCancelation  : "Kündigungsfrist",
        partner             : "Vertragspartner",
        action              : "Aktion",
        modified: {
            at: "Anpassung am",
            by: "durch"
        },

        payment: {
            title             : "Zahlungsweise",
            validation: {
                query: "Wirklich speichern?",
                text : "Es gibt noch Eingaben, die noch nicht den geforderten Werten ensprechen. Mit <b>JA</b> werden diese Werte ungeprüft gespeichert."
            }
        },

        toc: {
            until      : "bis",
            months     : "Monate",
            max3       : "max. 3 Monate",
            max6       : "max. 6 Monate",
            max12      : "max. 12 Monate",
            renewal: {
                automatic: "autom. Verlängerung",
                duration : "Anzahl",
                period   : "Periode",
                error    : "Anzahl ungültig"
            }
        },
        lim: {
            title           : "Liftmanagement",
            fulltitle       : "LIM Vertrag",
            pricePerMonth   : "Preis pro Monat",
            lgsPerMonth     : "Preis LG Smart pro Monat",
            splitMaintenance: "Anteil Wartung",
            splitRepair     : "Anteil Instandsetzung",
            invoiceHandling : "Gruppierung",
            tier            : "Vertragsstufe"
        },
        dls: {
            title           : "DLS",
            fulltitle       : "DLS Vertrag",
            netamount       : "EK",
            grossamount     : "VK"
        },
        mnt: {
            title                  : "Wartung",
            label                  : "W",
            contracttype           : "Wartungsart",
            costsPerYear           : "Kosten pro Jahr",
            countPerYear           : "Wartungen pro Jahr",
            rentIncluded           : "Miete ",
            standByIncluded        : "Bereitschaft",
            phoneIncluded          : "Telefon",
            guardIncluded          : "Aufzugswärter",
            teleserviceIncluded    : "Teleservice",
            smokeextractionIncluded: "Schachtentrauchung",
            inspectionIncluded     : "ZÜS Prüfungen",
            inspectioAddOnIncluded : "Monteurgestellung",
            inspectioAddOnIncludedTooltip:"Inkl. Monteurgestellung für ZÜS-Prüfungen und Prüfgewichte/Prüfsystem",
            incidentIncluded       : "Störungsbeseitigung",
            service                : "Service",
            prmanager              : "Verwalter"
        },
        esc: {
            title           : "Notruf",
            fulltitle       : "Notrufnehmer",
            label           : "N",
            costs           : "Kosten",
            rentPerYear     : "Mietkosten",
            standByPerYear  : "Bereitschaft",
            phoneCosts      : "Telefonkosten",
            guardCosts      : "Aufzugswärter",
            gadgetRent      : "Notrufgerät"
        },
        zus: {
            title: "ZÜS",
            fulltitle            : "ZÜS Vertrag",
            costsMainAudit       : "Hauptprüfung",
            costIntermediateAudit: "Zwischenprüfung",
            costAuditAfterChange : "Nach Änderung",
            costAuditAfterDefects: "Nach Mängelbeseitigung",
        },
        recipient : {
            all             : "Rechnungs-/Leistungsempfänger",
            invoice         : "Rechnungsempfänger",
            benefit         : "Leistungsempfänger",
        },

        renew: {
            title: "Vertragslaufzeit verlängern?",
            text: {
                contract: "Sollen das Vertragsende aller Anlagen des Vertrags verlängert werden, wenn notwendig? Mit <b>JA</b> wird die Verlängerung durchgeführt.",
                all     : "Sollen das Vertragsende aller Anlagen der Anzeige verlängert werden? Mit <b>JA</b> wird die Verlängerung durchgeführt."
            }
        },

        modType: {
            MODIFIED: "Änderung",
            ASSIGNED: "Zuweisung",
            DISSOLVED: "Aulösung",
            RENEWED  : "Verlängerung",
            CUSTOMER : "Neuer Kunde"
        }
    },
}